import { countries } from 'typed-countries';
import { OptionItem } from 'interfaces/OptionItem';

export const countryOptions = () => {
  return countries
    .filter(x => ['US', 'CA'].includes(x.iso))
    .map<OptionItem>((country) => ({
      value: country.iso,
      label: country.name,
    }));
};

export const stateOptions = (iso: string) => {
  if (!iso) return [];
  const country = countries.find((c) => c.iso === iso);
  if (!country) return [];

  return country.states.map<OptionItem>((state) => ({
    value: state.iso,
    label: state.name,
  }));
};

export const getPostalCodeRegex = (iso: string) => {
  const countriesRegex = [
    {
      iso: 'US',
      regex: /^\d{1,5}(-\d{0,4})?$/
    },
    {
      iso: 'CA',
      regex: /^(?!.*[DFIOQU])[A-VXY][0-9]?[A-Z]? *[0-9]?[A-Z]?[0-9]?$/
    },
  ]
  return countriesRegex.find(r => r.iso === iso).regex;
}
